import { render, staticRenderFns } from "./ModalAddOrg.vue?vue&type=template&id=dd119212&scoped=true"
import script from "./ModalAddOrg.vue?vue&type=script&lang=js"
export * from "./ModalAddOrg.vue?vue&type=script&lang=js"
import style0 from "./ModalAddOrg.vue?vue&type=style&index=0&id=dd119212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd119212",
  null
  
)

export default component.exports